import React from 'react';
import { cn } from '@/lib/utils';

interface GlassCardProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'dark';
}

export const GlassCard: React.FC<GlassCardProps> = ({ 
  children, 
  className, 
  variant = 'default' 
}) => {
  return (
    <div 
      className={cn(
        'backdrop-blur-md rounded-3xl shadow-xl border transition-all duration-300 hover:shadow-2xl',
        variant === 'default' 
          ? 'bg-white/10 border-white/20' 
          : 'bg-black/10 border-black/20',
        className
      )}
    >
      {children}
    </div>
  );
};